(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-shared/assets/javascripts/views/partner-signup.js') >= 0) return;  svs.modules.push('/modules/grassroots-shared/assets/javascripts/views/partner-signup.js');

(function(Backbone, _, svs) {
  'use strict';

  svs.grassroots.views.PartnerSignup = Marionette.View.extend({
    template: function(data) {
      return svs.grassroots.templates.partner_signup(data);
    },
    modelEvents: {
      change: 'render'
    },
    templateContext: {
      grassrootsPartnerLogin: svs.grassroots.data.config.grassrootsPartnerLogin
    },
    className: 'js-grassroots-search-wrapper bg-white grassroots-pop-up',
    initialize: function() {
      if (svs.core.detect.formfactor.mobile()) {
        svs.core.template.updateConfig({
          title: 'ANSLUT DIN FÖRENING'
        });
      }
    },
    onAttach: function() {
      var $body = $('body');
      $('.js-grassroots-search-wrapper').css(
        'min-height',
        $body.height() - ($('#top-content').height() + 24)
      );
      $body.scrollTop(0);
      $body.scrollLeft(0);
    }
  });
})(Backbone, _, svs);


 })(window);